module.exports = __webpack_public_path__ + "static/media/ctre45.6018b4d4.png";